import { z } from 'zod';
import {
  HOSTING_TYPES,
  HostingType,
} from '../../network/httpClients/RepositoryClient/api.schema';
import { spawn } from '../../utils/translations';
import { FIELDS } from './consts';
import {
  getOrgNameFromUrl,
  isGithubOrgRootUrl,
  isSaasHostname,
  isValidSelfHostedGithubUrl,
  prependHttpsIfNeeded,
} from './utils';

export const getOrganizationDetailsFormSchema = (hostingType: HostingType) => {
  const spawnValidations = spawn(
    'dialogs.github-installation.organization-details-form.validations',
  );

  const isSelfHosted = hostingType === HOSTING_TYPES.SELF_HOSTED;

  return z.object({
    [FIELDS.ORGANIZATION_URL]: z
      .string()
      .min(1, spawnValidations('organization-url.required'))
      .check((ctx) => {
        try {
          const urlToValidate = prependHttpsIfNeeded(ctx.value);

          new URL(urlToValidate);
        } catch {
          ctx.issues.push({
            code: 'custom',
            message: spawnValidations('organization-url.invalid-url'),
            input: ctx.value,
            path: [],
          });
        }
      })
      .check((ctx) => {
        try {
          const urlToValidate = prependHttpsIfNeeded(ctx.value);
          const url = new URL(urlToValidate);

          if (isSelfHosted) {
            const result = isValidSelfHostedGithubUrl(url);

            if (!result.ok) {
              ctx.issues.push({
                code: 'custom',
                message: spawnValidations(
                  'organization-url.invalid-self-hosted',
                ),
                input: ctx.value,
                path: [],
              });
            }

            return;
          }

          if (!isGithubOrgRootUrl(url)) {
            ctx.issues.push({
              code: 'custom',
              message: spawnValidations('organization-url.invalid-github-url'),
              input: ctx.value,
              path: [],
            });

            return;
          }

          if (!isSaasHostname(url.hostname)) {
            ctx.issues.push({
              code: 'custom',
              message: spawnValidations('organization-url.must-be-github-com'),
              input: ctx.value,
              path: [],
            });

            return;
          }

          const orgName = getOrgNameFromUrl(url);

          if (!orgName) {
            ctx.issues.push({
              code: 'custom',
              message: spawnValidations('organization-url.missing-org-name'),
              input: ctx.value,
              path: [],
            });
          }
        } catch {
          // URL parsing already handled in previous check
        }
      }),
  });
};
